import { render, staticRenderFns } from "./VRangeSlider.vue?vue&type=template&id=8ef3620c&scoped=true&"
import script from "./VRangeSlider.vue?vue&type=script&lang=ts&"
export * from "./VRangeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./VRangeSlider.vue?vue&type=style&index=0&id=8ef3620c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef3620c",
  null
  
)

export default component.exports